import { render, staticRenderFns } from "./RoomItem.vue?vue&type=template&id=195dbf06&scoped=true&"
import script from "./RoomItem.vue?vue&type=script&lang=ts&"
export * from "./RoomItem.vue?vue&type=script&lang=ts&"
import style0 from "./RoomItem.vue?vue&type=style&index=0&id=195dbf06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195dbf06",
  null
  
)

export default component.exports